/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.75 0c1.6569 0 3 1.3432 3 3v18c0 1.6569-1.3431 3-3 3H5.25c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3h13.5Zm0 1.5H5.25c-.7693 0-1.4033.579-1.49 1.325L3.75 3v18c0 .7693.579 1.4033 1.325 1.4899l.175.0101h13.5c.7693 0 1.4033-.5791 1.4899-1.3251L20.25 21V3c0-.7692-.5791-1.4033-1.3251-1.49L18.75 1.5ZM7.5 6.0027a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Zm2.25 6.0466a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm-2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2.25 5.9812a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm-2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
    clipRule="evenodd"
  />,
  'MenuDocuments'
);
